module.exports = __webpack_public_path__ + "static/media/Extruded tooth15.6c1e2fb8.png";